<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card bg-pattern">
            <div class="card-body p-4">
              <div class="text-center w-75 m-auto">
                <a class="app-name" href="https://www.freelanceinsights.com">
                  <span>Freelance</span>
                  <span>Insights</span>
                </a>
                <p class="text-muted mb-4 mt-3">
                  Enter your email address and password to access your account.
                </p>
              </div>

              <form @submit.prevent="onSubmit">
                <b-alert v-if="$enums.SESSION.LOGIN_FAILED.eql(session_status)" show variant="danger">
                  <h3 class="size-0 mt-0">
                    Error
                  </h3>
                  <ul class="mb-0">
                    <li v-for="(err, index) in session_errors" :key="index">
                      {{ err }}
                    </li>
                  </ul>
                </b-alert>

                <b-form-group
                  label="Email Address"
                  label-for="email-input"
                >
                  <b-form-input id="email-input" v-model="email" type="email" :required="true" placeholder="Enter your email" />
                </b-form-group>

                <b-form-group
                  label="Password"
                  label-for="password-input"
                >
                  <b-form-input id="password-input" v-model="password" type="password" :required="true" placeholder="Enter your password" />
                </b-form-group>

                <div class="form-group mb-3">
                  <div class="custom-control custom-checkbox">
                    <input id="checkbox-signin" type="checkbox" class="custom-control-input" checked>
                    <label class="custom-control-label" for="checkbox-signin">Remember me</label>
                  </div>
                </div>

                <div class="form-group mb-0 text-center">
                  <button :disabled="$enums.SESSION.LOGGING_IN.eql(session_status)" class="btn btn-primary btn-block" type="submit">
                    <template v-if="$enums.SESSION.LOGGING_IN.eql(session_status)">
                      <b-spinner small />
                      <span class="ml-1">Logging In...</span>
                    </template>
                    <template v-else>
                      Log In
                    </template>
                  </button>
                </div>
              </form>
            </div> <!-- end card-body -->
          </div>
          <!-- end card -->

          <div class="row mt-3">
            <div class="col-12 text-center">
              <p> <a href="pages-recoverpw.html" class="text-white-50 ml-1">Forgot your password?</a></p>
              <p class="text-white-50">
                Don't have an account? <router-link :to="{ name: 'Signup' }" class="text-white ml-1">
                  <b>Sign Up</b>
                </router-link>
              </p>
            </div> <!-- end col -->
          </div>
          <!-- end row -->
        </div> <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>

<script>
import {
  mapState,
  mapGetters,
} from 'vuex';

import {
  BFormGroup,
  BFormInput,
  BAlert,
  BSpinner,
} from 'bootstrap-vue';

import SESSION_STATUS from '@/enums/Session';
import types from '@/store/types/authorization';


export default {
  name: 'LoginView',
  components: {
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-alert': BAlert,
    'b-spinner': BSpinner,
  },

  data() {
    return {
      email: '',
      password: '',
    };
  },

  computed: {
    ...mapState({
      session_status: state => state.authorization.session_status,
      session_errors: state => state.authorization.session_errors,
    }),

    ...mapGetters([
      'isError',
    ]),
  },

  methods: {
    onSubmit() {
      this.onLoginUser(this.email, this.password);
    },

    /**
		 * Handler for `login` event of the `Login` component.
		 * This will attempt a login and, if successful, move them to the `home` route.
		 * @method
		 * @param  {string}  email    The email address of the user
		 * @param  {string}  password The password of the user
		 * @return {Promise}          [description]
		 */
    async onLoginUser(email, password) {
      const status = await this.$store.dispatch(types.actions.LOGIN_USER, {
        email,
        password,
      });

      if (SESSION_STATUS.LOGGED_IN.eql(status)) {
        this.$router.push({
          name: 'Home',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

h3 {
  font-size: 1.1rem;
}

</style>
